import { useEffect, useId, useRef } from 'react'
import Spinner from './Spinner'

// Native <dialog>-based confirmation modal (focus trap, initial focus and
// Escape handling come from showModal). Replaces window.confirm for
// destructive actions. Escape and backdrop clicks are blocked while busy.
export default function ConfirmDialog({ open, title, message, confirmLabel = 'Confirm', busy = false, onConfirm, onClose }) {
  const ref = useRef(null)
  const titleId = useId()

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (open && !el.open) el.showModal()
    else if (!open && el.open) el.close()
  }, [open])

  return (
    <dialog
      ref={ref}
      className="modal"
      aria-labelledby={titleId}
      onCancel={e => { if (busy) e.preventDefault() }}
      onClose={() => { if (open) onClose() }}
    >
      <div className="modal-box w-full max-w-md">
        <h3 id={titleId} className="font-bold text-lg mb-2">{title}</h3>
        <p className="text-sm opacity-80">{message}</p>
        <div className="modal-action mt-4">
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="btn btn-error btn-sm" onClick={onConfirm} disabled={busy} aria-busy={busy}>
            {busy ? <Spinner size="xs" /> : confirmLabel}
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button disabled={busy} aria-label="Close">close</button>
      </form>
    </dialog>
  )
}
